import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, Transition as _Transition, Teleport as _Teleport, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/icons/add.png'


const _withScopeId = n => (_pushScopeId("data-v-364b558c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-container mt-8 content-start items-start" }
const _hoisted_2 = { class: "flex col-start-1 col-end-13 justify-between items-center w-full" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "ac-large-title mb-0" }, "Stok Yönetimi", -1))
const _hoisted_4 = { class: "flex items-center gap-6" }
const _hoisted_5 = { class: "flex items-center gap-2 text-xl cursor-pointer" }
const _hoisted_6 = ["checked"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "mr-4 filter-main",
  width: "20",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_8 = {
  key: 0,
  class: "alt-table col-start-1 col-end-13 w-full mt-5 hidden md:table"
}
const _hoisted_9 = { class: "sort-indicator" }
const _hoisted_10 = { class: "sort-indicator" }
const _hoisted_11 = { class: "sort-indicator" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Miktar", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Konum", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "text-right" }, "İşlemler", -1))
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "text-overflow font-medium" }
const _hoisted_17 = { class: "inline-flex items-center gap-2" }
const _hoisted_18 = {
  key: 0,
  title: "Yenileme eşiği aşıldı"
}
const _hoisted_19 = { class: "text-overflow" }
const _hoisted_20 = { class: "text-overflow" }
const _hoisted_21 = {
  key: 0,
  class: "font-semibold text-red-600"
}
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "text-overflow" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "16",
  height: "16",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z" }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "12",
    r: "3"
  })
], -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "16",
  height: "16",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("line", {
    x1: "12",
    y1: "5",
    x2: "12",
    y2: "19"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "5",
    y1: "12",
    x2: "19",
    y2: "12"
  })
], -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "16",
  height: "16",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("line", {
    x1: "5",
    y1: "12",
    x2: "19",
    y2: "12"
  })
], -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = { key: 0 }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "6",
  class: "text-center text-gray-400 py-8"
}, "Henüz ürün eklenmemiş.", -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = {
  key: 1,
  class: "col-start-1 col-end-13 w-full mt-5 flex flex-col gap-4 md:hidden"
}
const _hoisted_37 = { class: "inventory-card__title" }
const _hoisted_38 = {
  key: 0,
  title: "Yenileme eşiği aşıldı"
}
const _hoisted_39 = { class: "inventory-card__row" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "inventory-card__label" }, "Marka", -1))
const _hoisted_41 = { class: "inventory-card__row" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "inventory-card__label" }, "Kategori", -1))
const _hoisted_43 = { class: "inventory-card__row" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "inventory-card__label" }, "Miktar", -1))
const _hoisted_45 = {
  key: 0,
  class: "font-semibold text-red-600"
}
const _hoisted_46 = { key: 1 }
const _hoisted_47 = { class: "inventory-card__row" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "inventory-card__label" }, "Konum", -1))
const _hoisted_49 = { class: "inventory-card__actions" }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "16",
  height: "16",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z" }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "12",
    r: "3"
  })
], -1))
const _hoisted_52 = [
  _hoisted_51
]
const _hoisted_53 = ["onClick"]
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "16",
  height: "16",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("line", {
    x1: "12",
    y1: "5",
    x2: "12",
    y2: "19"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "5",
    y1: "12",
    x2: "19",
    y2: "12"
  })
], -1))
const _hoisted_55 = [
  _hoisted_54
]
const _hoisted_56 = ["onClick"]
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "16",
  height: "16",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("line", {
    x1: "5",
    y1: "12",
    x2: "19",
    y2: "12"
  })
], -1))
const _hoisted_58 = [
  _hoisted_57
]
const _hoisted_59 = {
  key: 0,
  class: "text-center text-gray-400 py-8"
}
const _hoisted_60 = {
  key: 2,
  class: "col-start-1 col-end-13 w-full mt-12"
}
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3xl font-semibold mb-4" }, "Arşivlenen Ürünler", -1))
const _hoisted_62 = {
  key: 0,
  class: "text-gray-500 py-4"
}
const _hoisted_63 = {
  key: 1,
  class: "alt-table w-full"
}
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Ürün"),
    /*#__PURE__*/_createElementVNode("th", null, "Marka"),
    /*#__PURE__*/_createElementVNode("th", null, "Kategori"),
    /*#__PURE__*/_createElementVNode("th", null, "Miktar"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-right" }, "İşlemler")
  ])
], -1))
const _hoisted_65 = { class: "text-overflow font-medium" }
const _hoisted_66 = { class: "text-overflow" }
const _hoisted_67 = { class: "text-overflow" }
const _hoisted_68 = { class: "flex items-center justify-end" }
const _hoisted_69 = ["onClick"]
const _hoisted_70 = {
  key: 2,
  class: "text-gray-400 py-4"
}
const _hoisted_71 = { class: "mb-4 text-xl px-2" }
const _hoisted_72 = { class: "ac-main-form !border-none" }
const _hoisted_73 = { class: "mb-4 text-xl" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-4 text-lg text-gray-500" }, "En eski partiden başlayarak (FIFO) düşülecektir.", -1))
const _hoisted_75 = { class: "ac-form-control w-full" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "removeAmount" }, "Çıkarılacak miktar", -1))
const _hoisted_77 = ["max"]
const _hoisted_78 = { class: "ac-form-control w-full" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "removeWorksite" }, "Gönderilen Şantiye", -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Şantiye Belirtilmemiş", -1))
const _hoisted_81 = ["value"]

import { ref, computed, onBeforeMount, onBeforeUnmount } from "vue"
import { useStore } from "vuex"
import { useRouter } from "vue-router"
import firebase from "@/firebase"
import { useGetDocs, useGetFilteredDocs, postData, updateData } from "@/mixins/modularFirebaseOperations"
import { formatUser, modalClosed } from "@/mixins/visualFormatters"
import { getQuantityLabel, createBatch, requiresWholeUnits, addBatchTransaction, removeStockTransaction } from "@/composables/inventoryHelpers"
import resetBackground from "@/mixins/resetBackground"
import removeBackground from "@/mixins/removeBackground"
import AcMediumModal from "@/components/reusable/teleports/acMediumModal.vue"
import InventoryItemForm from "@/components/reusable/form-widgets/inventoryItemForm.vue"
import InventoryBatchForm from "@/components/reusable/form-widgets/inventoryBatchForm.vue"
import type { AcInventoryItem, AcInventoryBatch, AcInventoryUpdate, AcInventoryWorksite } from "@/types/inventory"

const COLLECTION = "inventory/items/list"

type SortKey = "productName" | "brand" | "category"

export default /*#__PURE__*/_defineComponent({
  __name: 'inventoryList',
  setup(__props) {


const router = useRouter()
const store = useStore()
const userProfile = computed(() => store.getters["user/userProfile"])
const formattedUser = computed(() => formatUser(userProfile.value))

const { docs, isLoadingDocs } = useGetFilteredDocs<AcInventoryItem>(COLLECTION, { status: "ACTIVE" })
const items = docs as unknown as import("vue").Ref<(AcInventoryItem & { id: string })[]>

// Active worksites offered as removal destinations.
const { docs: worksites } = useGetDocs<AcInventoryWorksite>("inventory/worksites/list")
const activeWorksites = computed(() => worksites.value.filter((w) => w.isActive))

// ---- Sorting (defaults to alphabetical by product name) ----
const sortKey = ref<SortKey>("productName")
const sortDir = ref<"asc" | "desc">("asc")

const sortValue = (item: AcInventoryItem, key: SortKey) => {
    if (key === "brand") return item.productBrand?.name ?? ""
    if (key === "category") return item.productCategory?.name ?? ""
    return item.productName ?? ""
}

const toggleSort = (key: SortKey) => {
    if (sortKey.value === key) {
        sortDir.value = sortDir.value === "asc" ? "desc" : "asc"
    } else {
        sortKey.value = key
        sortDir.value = "asc"
    }
}

const sortIndicator = (key: SortKey) => {
    if (sortKey.value !== key) return ""
    return sortDir.value === "asc" ? "▲" : "▼"
}

const visibleItems = computed(() => {
    const filtered = items.value.filter((item) => item.status === "ACTIVE")
    const dir = sortDir.value === "asc" ? 1 : -1
    return [...filtered].sort((a, b) =>
        dir * sortValue(a, sortKey.value).localeCompare(sortValue(b, sortKey.value), "tr", { sensitivity: "base" })
    )
})

// ---- Archived items (lazy-loaded restore view) ----
const showArchived = ref(false)
const archivedItems = ref<(AcInventoryItem & { id: string })[]>([])
const isLoadingArchived = ref(false)
const archivedLoaded = ref(false)

const loadArchivedItems = async () => {
    if (archivedLoaded.value) return
    isLoadingArchived.value = true
    try {
        const snap = await firebase.firestore().collection(COLLECTION).where("status", "==", "ARCHIVED").get()
        archivedItems.value = snap.docs.map((doc) => ({ id: doc.id, ...doc.data() } as AcInventoryItem & { id: string }))
        archivedLoaded.value = true
    } catch (error) {
        console.error(error)
    } finally {
        isLoadingArchived.value = false
    }
}

const toggleArchived = async () => {
    showArchived.value = !showArchived.value
    if (showArchived.value) await loadArchivedItems()
}

const restoreItem = async (item: AcInventoryItem & { id: string }) => {
    if (!confirm("Bu ürünü geri yüklemek istediğinize emin misiniz?")) return
    await updateData(COLLECTION, item.id, {
        status: "ACTIVE",
        updatedAt: new Date(),
        updatedBy: formattedUser.value,
    })
    archivedItems.value = archivedItems.value.filter((i) => i.id !== item.id)
    items.value.push({ ...item, status: "ACTIVE" })
}

const isAddingItem = ref(false)

// Add-batch modal state
const batchModalItem = ref<(AcInventoryItem & { id: string }) | null>(null)
// Remove (FIFO consume) modal state
const removeModalItem = ref<(AcInventoryItem & { id: string }) | null>(null)
const removeModalAmount = ref<number | null>(null)
const removeModalWorksiteId = ref<string>("")

const handleItemAdded = async (item: Partial<AcInventoryItem>) => {
    try {
        // The first purchase batch is seeded from the form's quantity + unit price + condition.
        const firstBatch = createBatch({
            quantity: item.quantity as number,
            unitPrice: item.originalPrice as number,
            purchaseCurrency: (item.purchaseCurrency ?? "TRY") as NonNullable<AcInventoryBatch["purchaseCurrency"]>,
            condition: (item.condition ?? "NEW") as NonNullable<AcInventoryBatch["condition"]>,
            addedBy: formattedUser.value,
        })

        const finalItem: Partial<AcInventoryItem> = {
            ...item,
            batches: [firstBatch],
            quantity: firstBatch.quantity,
            status: "ACTIVE",
            addedBy: formattedUser.value,
            updatedBy: formattedUser.value,
            createdAt: new Date(),
            updatedAt: new Date(),
            updates: [],
            comments: [],
        }
        const newId = await postData(finalItem, COLLECTION)
        items.value.push({ ...(finalItem as AcInventoryItem), id: newId as string })
    } catch (error) {
        console.error(error)
    } finally {
        isAddingItem.value = false
        modalClosed()
    }
}

// Sync the local (one-time fetched) item with the state persisted by a transaction.
const applyMovementResult = (
    item: AcInventoryItem & { id: string },
    result: { batches: AcInventoryItem["batches"], quantity: number, update: AcInventoryUpdate }
) => {
    item.batches = result.batches
    item.quantity = result.quantity
    if (!item.updates) item.updates = []
    item.updates.push(result.update)
}

// ---- Add stock (new batch) ----
const openBatchModal = (item: AcInventoryItem & { id: string }) => {
    batchModalItem.value = item
}
const closeBatchModal = () => {
    batchModalItem.value = null
    modalClosed()
}
const handleBatchSubmitted = async (payload: any) => {
    const item = batchModalItem.value
    if (!item) return
    const batch = createBatch({ ...payload, addedBy: formattedUser.value })
    try {
        const result = await addBatchTransaction(item.id, batch, formattedUser.value, item.quantityType)
        applyMovementResult(item, result)
    } catch (error: any) {
        alert(error?.message ?? `Bir hata oluştu: ${error}`)
        return
    }
    closeBatchModal()
}

// ---- Remove stock (FIFO consume) ----
const openRemoveModal = (item: AcInventoryItem & { id: string }) => {
    removeModalItem.value = item
    removeModalAmount.value = null
    removeModalWorksiteId.value = ""
}
const closeRemoveModal = () => {
    removeModalItem.value = null
    removeModalAmount.value = null
    removeModalWorksiteId.value = ""
    modalClosed()
}
const confirmRemove = async () => {
    const item = removeModalItem.value
    const amount = Number(removeModalAmount.value)
    if (!item) return
    const label = getQuantityLabel(item.quantityType)
    if (isNaN(amount) || amount <= 0) {
        alert("Lütfen geçerli bir miktar giriniz.")
        return
    }
    if (requiresWholeUnits(item.quantityType) && !Number.isInteger(amount)) {
        alert("Bu ürün adet ile takip edilir; lütfen tam sayı giriniz.")
        return
    }
    if (amount > item.quantity) {
        alert(`Mevcut stoktan (${item.quantity} ${label}) daha fazlasını çıkaramazsınız.`)
        return
    }
    const worksite = activeWorksites.value.find((w) => w.id === removeModalWorksiteId.value) ?? null
    try {
        const result = await removeStockTransaction(item.id, amount, formattedUser.value, item.quantityType, worksite)
        applyMovementResult(item, result)
    } catch (error: any) {
        alert(error?.message ?? `Bir hata oluştu: ${error}`)
        return
    }
    closeRemoveModal()
}

const goToDetail = (item: AcInventoryItem & { id: string }) => {
    router.push(`/inventory/item/${item.id}`)
}

// True when the item's stock has reached or fallen below its renewal threshold.
const isBelowThreshold = (item: AcInventoryItem) =>
    item.renewThreshold != null && item.renewThreshold > 0 && item.quantity <= item.renewThreshold

onBeforeMount(() => {
    removeBackground.methods.removeBackground()
})

onBeforeUnmount(() => {
    resetBackground.methods.resetBackground()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("label", _hoisted_5, [
          _createElementVNode("input", {
            type: "checkbox",
            checked: showArchived.value,
            onChange: toggleArchived
          }, null, 40, _hoisted_6),
          _createTextVNode(" Arşivlenenleri göster ")
        ]),
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (isAddingItem.value = true)),
          class: "ac-add-button"
        }, [
          _hoisted_7,
          _createTextVNode(" Yeni Ürün Ekle ")
        ])
      ])
    ]),
    (!_unref(isLoadingDocs))
      ? (_openBlock(), _createElementBlock("table", _hoisted_8, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", {
                class: "sortable-th",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleSort('productName')))
              }, [
                _createTextVNode(" Ürün "),
                _createElementVNode("span", _hoisted_9, _toDisplayString(sortIndicator('productName')), 1)
              ]),
              _createElementVNode("th", {
                class: "sortable-th",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleSort('brand')))
              }, [
                _createTextVNode(" Marka "),
                _createElementVNode("span", _hoisted_10, _toDisplayString(sortIndicator('brand')), 1)
              ]),
              _createElementVNode("th", {
                class: "sortable-th",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (toggleSort('category')))
              }, [
                _createTextVNode(" Kategori "),
                _createElementVNode("span", _hoisted_11, _toDisplayString(sortIndicator('category')), 1)
              ]),
              _hoisted_12,
              _hoisted_13,
              _hoisted_14
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleItems.value, (item) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: item.id,
                class: "hover:bg-gray-100 cursor-pointer",
                onClick: ($event: any) => (goToDetail(item))
              }, [
                _createElementVNode("td", _hoisted_16, [
                  _createElementVNode("span", _hoisted_17, [
                    (isBelowThreshold(item))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, "⚠️"))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(item.productName), 1)
                  ])
                ]),
                _createElementVNode("td", _hoisted_19, _toDisplayString(item.productBrand?.name || "-"), 1),
                _createElementVNode("td", _hoisted_20, _toDisplayString(item.productCategory?.name || "-"), 1),
                _createElementVNode("td", null, [
                  (item.quantity === 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, "Stokta yok"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(item.quantity) + " " + _toDisplayString(_unref(getQuantityLabel)(item.quantityType)), 1))
                ]),
                _createElementVNode("td", _hoisted_23, _toDisplayString(item.location?.name || "-"), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("div", {
                    class: "flex items-center justify-end gap-2",
                    onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
                  }, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "icon-action-button",
                      title: "Detayları Görüntüle",
                      onClick: ($event: any) => (goToDetail(item))
                    }, _hoisted_26, 8, _hoisted_24),
                    _createElementVNode("button", {
                      type: "button",
                      class: "icon-action-button icon-action-button--add",
                      title: "Stok Ekle (Yeni Parti)",
                      onClick: ($event: any) => (openBatchModal(item))
                    }, _hoisted_29, 8, _hoisted_27),
                    _createElementVNode("button", {
                      type: "button",
                      class: "icon-action-button icon-action-button--remove",
                      title: "Stok Çıkar",
                      onClick: ($event: any) => (openRemoveModal(item))
                    }, _hoisted_32, 8, _hoisted_30)
                  ])
                ])
              ], 8, _hoisted_15))
            }), 128)),
            (visibleItems.value.length === 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_33, _hoisted_35))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (!_unref(isLoadingDocs))
      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleItems.value, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.id,
              class: "inventory-card"
            }, [
              _createElementVNode("h3", _hoisted_37, [
                (isBelowThreshold(item))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_38, "⚠️"))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(item.productName), 1)
              ]),
              _createElementVNode("div", _hoisted_39, [
                _hoisted_40,
                _createElementVNode("span", null, _toDisplayString(item.productBrand?.name || "-"), 1)
              ]),
              _createElementVNode("div", _hoisted_41, [
                _hoisted_42,
                _createElementVNode("span", null, _toDisplayString(item.productCategory?.name || "-"), 1)
              ]),
              _createElementVNode("div", _hoisted_43, [
                _hoisted_44,
                (item.quantity === 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_45, "Stokta yok"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(item.quantity) + " " + _toDisplayString(_unref(getQuantityLabel)(item.quantityType)), 1))
              ]),
              _createElementVNode("div", _hoisted_47, [
                _hoisted_48,
                _createElementVNode("span", null, _toDisplayString(item.location?.name || "-"), 1)
              ]),
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("button", {
                  type: "button",
                  class: "icon-action-button",
                  title: "Detayları Görüntüle",
                  onClick: ($event: any) => (goToDetail(item))
                }, _hoisted_52, 8, _hoisted_50),
                _createElementVNode("button", {
                  type: "button",
                  class: "icon-action-button icon-action-button--add",
                  title: "Stok Ekle (Yeni Parti)",
                  onClick: ($event: any) => (openBatchModal(item))
                }, _hoisted_55, 8, _hoisted_53),
                _createElementVNode("button", {
                  type: "button",
                  class: "icon-action-button icon-action-button--remove",
                  title: "Stok Çıkar",
                  onClick: ($event: any) => (openRemoveModal(item))
                }, _hoisted_58, 8, _hoisted_56)
              ])
            ]))
          }), 128)),
          (visibleItems.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_59, "Henüz ürün eklenmemiş."))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (showArchived.value)
      ? (_openBlock(), _createElementBlock("section", _hoisted_60, [
          _hoisted_61,
          (isLoadingArchived.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_62, "Yükleniyor..."))
            : (archivedItems.value.length)
              ? (_openBlock(), _createElementBlock("table", _hoisted_63, [
                  _hoisted_64,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(archivedItems.value, (item) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: item.id,
                        class: "opacity-70"
                      }, [
                        _createElementVNode("td", _hoisted_65, _toDisplayString(item.productName), 1),
                        _createElementVNode("td", _hoisted_66, _toDisplayString(item.productBrand?.name || "-"), 1),
                        _createElementVNode("td", _hoisted_67, _toDisplayString(item.productCategory?.name || "-"), 1),
                        _createElementVNode("td", null, _toDisplayString(item.quantity) + " " + _toDisplayString(_unref(getQuantityLabel)(item.quantityType)), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_68, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "table-button",
                              onClick: ($event: any) => (restoreItem(item))
                            }, " Geri Yükle ", 8, _hoisted_69)
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_70, "Arşivlenmiş ürün bulunmuyor."))
        ]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, {
        appear: "",
        type: "animation",
        "enter-active-class": "animate__animated animate__fadeIn animate__fast",
        "leave-active-class": "animate__animated animate__fadeOut animate__faster"
      }, {
        default: _withCtx(() => [
          (isAddingItem.value)
            ? (_openBlock(), _createBlock(AcMediumModal, {
                key: 0,
                class: "lg:!top-44 overflow-y-scroll",
                onModalClosed: _cache[6] || (_cache[6] = ($event: any) => (isAddingItem.value = false)),
                width: "60vw",
                height: "fit-content",
                title: "Yeni Ürün Ekle"
              }, {
                default: _withCtx(() => [
                  _createVNode(InventoryItemForm, {
                    onItemAdded: handleItemAdded,
                    onCancel: _cache[5] || (_cache[5] = ($event: any) => (isAddingItem.value = false))
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, {
        appear: "",
        type: "animation",
        "enter-active-class": "animate__animated animate__fadeIn animate__fast",
        "leave-active-class": "animate__animated animate__fadeOut animate__faster"
      }, {
        default: _withCtx(() => [
          (batchModalItem.value)
            ? (_openBlock(), _createBlock(AcMediumModal, {
                key: 0,
                class: "lg:!top-44 overflow-y-scroll",
                width: "44vw",
                height: "fit-content",
                title: "Stok Ekle (Yeni Parti)",
                onModalClosed: closeBatchModal
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", _hoisted_71, [
                    _createElementVNode("strong", null, _toDisplayString(batchModalItem.value.productName), 1),
                    _createTextVNode(" — mevcut miktar: " + _toDisplayString(batchModalItem.value.quantity) + " " + _toDisplayString(_unref(getQuantityLabel)(batchModalItem.value.quantityType)), 1)
                  ]),
                  _createVNode(InventoryBatchForm, {
                    "quantity-label": _unref(getQuantityLabel)(batchModalItem.value.quantityType),
                    "default-currency": batchModalItem.value.purchaseCurrency,
                    "integer-only": _unref(requiresWholeUnits)(batchModalItem.value.quantityType),
                    onBatchSubmitted: handleBatchSubmitted,
                    onCancel: closeBatchModal
                  }, null, 8, ["quantity-label", "default-currency", "integer-only"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, {
        appear: "",
        type: "animation",
        "enter-active-class": "animate__animated animate__fadeIn animate__fast",
        "leave-active-class": "animate__animated animate__fadeOut animate__faster"
      }, {
        default: _withCtx(() => [
          (removeModalItem.value)
            ? (_openBlock(), _createBlock(AcMediumModal, {
                key: 0,
                class: "lg:!top-44",
                width: "34vw",
                height: "fit-content",
                title: "Stok Çıkar",
                onModalClosed: closeRemoveModal
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_72, [
                    _createElementVNode("p", _hoisted_73, [
                      _createElementVNode("strong", null, _toDisplayString(removeModalItem.value.productName), 1),
                      _createTextVNode(" — mevcut miktar: " + _toDisplayString(removeModalItem.value.quantity) + " " + _toDisplayString(_unref(getQuantityLabel)(removeModalItem.value.quantityType)), 1)
                    ]),
                    _hoisted_74,
                    _createElementVNode("div", _hoisted_75, [
                      _hoisted_76,
                      _withDirectives(_createElementVNode("input", {
                        id: "removeAmount",
                        type: "number",
                        min: "1",
                        max: removeModalItem.value.quantity,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((removeModalAmount).value = $event)),
                        onKeyup: _withKeys(confirmRemove, ["enter"])
                      }, null, 40, _hoisted_77), [
                        [_vModelText, removeModalAmount.value]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_78, [
                      _hoisted_79,
                      _withDirectives(_createElementVNode("select", {
                        id: "removeWorksite",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((removeModalWorksiteId).value = $event))
                      }, [
                        _hoisted_80,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeWorksites.value, (worksite) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: worksite.id,
                            value: worksite.id
                          }, _toDisplayString(worksite.name), 9, _hoisted_81))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, removeModalWorksiteId.value]
                      ])
                    ]),
                    _createElementVNode("div", { class: "flex items-center justify-center gap-6 w-full" }, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "ac-primary-button text-2xl mt-4",
                        onClick: confirmRemove
                      }, "Kaydet"),
                      _createElementVNode("button", {
                        type: "button",
                        class: "ac-secondary-button text-2xl mt-4",
                        onClick: closeRemoveModal
                      }, "İptal")
                    ])
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]))
  ]))
}
}

})